import React from "react"
import strings from "../../../../localization/strings"
import { IRecord } from "../../../../models"
import { grey800 } from "material-ui/styles/colors"
import ExternalLink from "../../../common/externalLink/ExternalLink"
import * as userHelper from "../../../../helpers/userHelper"
import AccountStore from "../../../../stores/AccountStore"
import * as hierarchyHelper from "../../../../helpers/hierarchyHelper"
import ExceptionBodyDeviceInfo from "./ExceptionBodyDeviceInfo"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import ExceptionBodyDeviceDialog from "./ExceptionBodyDeviceDialog"
import { checkJobFieldAvailable } from "../../../../helpers/jobHelper"
import * as timeHelper from "../../../../helpers/timeHelper"
import moment from "moment"
import { checkPhaseFieldAvailable } from "../../../../helpers/punchHelper"

interface IProps {
    record: IRecord
}

const ExceptionBody: React.SFC<IProps> = (props: IProps) => {
    const punchDateTimeLocal = moment(timeHelper.keepConvertUTCToLocal(props.record.Punch.DateTimeLocal))
    return (
        <div className="exception-review-body">
            <div>
                <b style={{ marginRight: 15 }}>{strings.Employee}:</b>
                <span style={{ marginRight: 5 }}>{`${props.record.UserFirstName} ${props.record.UserLastName}`}</span>
                <ExternalLink
                    fontSize={"16px"}
                    iconColor={grey800}
                    url={"/user-details/" + props.record.Punch.UserId + "/" + userHelper.getValidSubPages()[0]}
                />
            </div>
            <div>
                <b style={{ marginRight: 15 }}>{strings.Employee_ID}:</b>
                <span style={{ marginRight: 5 }}>{props.record.UserExternalId}</span>
            </div>
            <div>
                <b style={{ marginRight: 15 }}>{strings.Hierarchy}:</b>
                <span style={{ marginRight: 5 }}>{hierarchyHelper.getFullyQualifiedLevelNameById(props.record.Punch.HierarchyItemId)}</span>
            </div>
            {AccountStore.getJobsEnabled() &&
                <div>
                    <b style={{ marginRight: 15 }}>{checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Job}:</b>
                    <span style={{ marginRight: 5 }}>{props.record.Punch.JobName || ""}</span>
                    { props.record.Punch.JobId && <ExternalLink
                        fontSize={"16px"}
                        iconColor={grey800}
                        url={`/job-details/${props.record.Punch.JobId}`}
                    />}
                </div>
            }
            {AccountStore.getPhasesEnabled() &&
                <div>
                    <b style={{ marginRight: 15 }}>{ checkPhaseFieldAvailable("singular") ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel : strings.Phase}:</b>
                    <span style={{ marginRight: 5 }}>{props.record.Punch.PhaseName || ""}</span>
                </div>
            }
            <div>
                <b style={{ marginRight: 15 }}>{strings.Date}:</b>
                <span style={{ marginRight: 5 }}>{punchDateTimeLocal.format("MMM. DD, YYYY")}</span>
            </div>
            <div>
                <b style={{ marginRight: 15 }}>{strings.Time}:</b>
                <span style={{ marginRight: 5 }}>{punchDateTimeLocal.format("h:mm A")}</span>
            </div>
            <div style={{ display: "flex" }}>
                <b style={{ marginRight: 15 }}>{strings.Device_Name}:</b>
                <span style={{ marginRight: 5 }}>{props.record.DeviceName}</span>
                <ExceptionBodyDeviceInfo
                    deviceId={props.record.Punch.DeviceId}
                />
                {(permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.ViewAllDevices) || permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.EditAllDevices)) &&
                    <ExceptionBodyDeviceDialog
                        readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.EditAllDevices)}
                        deviceId={props.record.Punch.DeviceId}
                    />
                }
            </div>
        </div>
    )
}

export default ExceptionBody